import { useApolloClient } from '@apollo/react-hooks';
import { FETCH_ROLES } from '../GraphQL/Queries';
import logger from '../logger';

const useUpdateRolesCache = (tenantId) => {
  const client = useApolloClient();
  const updateCache = (role) => {
    try {
      const data = client.readQuery({
        query: FETCH_ROLES,
        variables: {
          tenantId,
        },
      });
      client.writeQuery({
        query: FETCH_ROLES,
        data: {
          fetchRoles: [
            ...data.fetchRoles,
            { ...role },
          ],
        },
        variables: {
          tenantId,
        },
      });
    } catch (e_) {
      logger('Update not needed!');
    }
  };

  return updateCache;
};

export default useUpdateRolesCache;
